// src/components/MicrosoftSSO.js
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/msalConfig';

const MicrosoftSSO = ({ onLoginSuccess, onLoginError }) => {
    const { instance } = useMsal();

    const handleMicrosoftLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);

            // Extract user information from the response
            const userInfo = {
                id: response.account.homeAccountId,
                email: response.account.username,
                name: response.account.name,
                accessToken: response.accessToken,
                idToken: response.idToken,
            };

            // Call the success callback with user info
            if (onLoginSuccess) {
                onLoginSuccess(userInfo);
            }
        } catch (error) {
            console.error('Microsoft SSO login failed:', error);
            if (onLoginError) {
                onLoginError(error);
            }
        }
    };

    return (
        <button
            type="button"
            onClick={handleMicrosoftLogin}
            className="w-100 sso-button microsoft-button"
            style={{
                width: '100%',
                height: '36px',
                fontSize: '0.95rem',
                fontWeight: 600,
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                color: '#36454f',
                textTransform: 'none',
                letterSpacing: '0.3px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
                e.target.style.borderColor = '#d1d5db';
                e.target.style.backgroundColor = '#f9fafb';
                e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
            }}
        >
            <svg width="21" height="21" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                <path fill="#f25022" d="M0 0h11v11H0z"/>
                <path fill="#00a4ef" d="M12 0h11v11H12z"/>
                <path fill="#7fba00" d="M0 12h11v11H0z"/>
                <path fill="#ffb900" d="M12 12h11v11H12z"/>
            </svg>
            Sign in with Microsoft
        </button>
    );
};

export default MicrosoftSSO;